import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { Button, Stack } from "@mui/material";
import s3kLogo from "../images/s3k-logo-alt2-512.png";
import GoogleSignIn from "./GoogleSignIn";
import { useIsMobile } from "../hooks/useIsMobile";
import { useUser } from "../context/UserContext";

export default function Sidebar({ isOpen, toggleSidebar }) {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { user, logout } = useUser();

  // navigation configuration buttons
  const navLinks = [
    { label: "Profile", path: "/profile" },
    { label: "Insurance", path: "/insurance" },
    { label: "Meetings", path: "/meetings" },
    { label: "Reimbursements", path: "/reimbursements" },
  ];

  // Shared navigation button styling
  const getNavButtonStyles = (theme) => ({
    height: isMobile ? "96px" : "64px",
    bgcolor: isMobile ? theme.palette.background.paper : null,
    "@media (hover: hover)": {
      "&:hover": {
        color: "#ffaaaa",
      },
    },
  });

  return (
    <Drawer
      anchor="left"
      open={isOpen}
      onClose={toggleSidebar(false)}
      PaperProps={{
        sx: (theme) => ({
          backgroundColor: theme.palette.background.default,
          width: isMobile ? "70vw" : null,
        }),
      }}
    >
      <Box
        sx={{ width: isMobile ? null : 250 }}
        role="presentation"
        onClick={toggleSidebar(false)}
        onKeyDown={toggleSidebar(false)}
      >
        <Stack spacing={user ? (isMobile ? 4 : 3) : 2}>
          {/* Header Logo */}
          {!isMobile && <Box sx={{ height: 3 }} />}
          <Button
            sx={{
              height: "64px",
              display: "flex",
              justifyContent: "center",
            }}
            onClick={() => navigate("/")}
          >
            <img
              src={s3kLogo}
              alt="S3K Logo"
              style={{ width: 40, height: 40, borderRadius: 0 }}
            />
          </Button>
          {!isMobile && <Box sx={{ height: 3 }} />}

          {/* Conditional Auth Navigation */}
          {!user ? (
            <GoogleSignIn />
          ) : (
            <>
              {navLinks.map((link) => (
                <Button
                  key={link.path}
                  sx={getNavButtonStyles}
                  onClick={() => navigate(link.path)}
                >
                  {link.label}
                </Button>
              ))}

              <Button
                variant="contained"
                sx={{ height: isMobile ? "96px" : "64px" }}
                onClick={logout}
              >
                Sign Out
              </Button>
            </>
          )}
        </Stack>
      </Box>
    </Drawer>
  );
}
